<template>
  <v-container fluid class="mx-0 px-0">
    <v-file-input
      class="fileInput"
      ref="fileInput"
      :accept="fileType"
      :multiple="multiple"
      @change="addFiles"
    ></v-file-input>
    <v-card
      ref="dragInput"
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      @click.prevent="clickUpload"
      :class="dragClass"
      :disabled="!canUpload"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon
            :class="[dragover ? 'mt-2, mb-6' : 'mt-5 ']"
            color="primary"
            size="60"
          >
            mdi-cloud-upload
          </v-icon>
          {{ uploadText }}
        </v-row>
        <v-list-item v-for="item in uploadedFiles" :key="item.name">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
              <span class="ml-3 text--secondary">
                {{ fileSize(item.size) }}</span
              >
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action v-if="!instant" class="my-0">
            <v-btn @click.stop="removeFile(item.name)" icon>
              <v-icon> mdi-close-circle </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <div>
          <v-progress-linear
            :value="progress"
            v-if="isUpload"
            color="light-blue"
            height="25"
            disabled
          >
            <strong>{{ progress }} %</strong>
          </v-progress-linear>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PerleidimasUpload',

  props: {
    uploadedFiles: Array,
    fileType: { type: String, default: '.pdf,.adoc,.asice' },
    multiple: { type: Boolean, default: false },
    instant: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    maxDydis: { type: Number, default: 0 },
    progress: { type: Number, default: 0 },
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      dragover: false,
      // uploadedFiles: [],
    }
  },
  computed: {
    ...mapGetters(['objektasID']),

    dragClass() {
      return (this.dragover ? 'blue lighten-1' : '') + 'mb-2'
    },
    isUpload() {
      return this.uploadedFiles.length > 0
    },
    uploadText() {
      return 'Paspauskite arba įtempkite rinkmeną'
    },
    canUpload() {
      return !this.isReadonly
    },
    fileTypeList() {
      return this.fileType.replaceAll('.', '').split(',')
    },
    maxDydisByte() {
      return this.maxDydis * 1024 * 1024
    },
    uploadClass() {
      return `v-label theme--light ${
        this.uploadRequired ? 'required-text' : ''
      } ${this.uploadError ? 'error--text' : ''}`
    },
    uploadRequired() {
      return !this.selectedPaslauga.includes('patikraHipoteka')
        ? 'required'
        : ''
    },
    uploadError() {
      return !this.uploadValidated
    },
    isReadonly() {
      return this.readonly
    },
  },
  created() {
    //
  },
  methods: {
    clickUpload() {
      this.$refs.dragInput.$el.blur()
      this.$refs.fileInput.$refs.input.click()
    },
    addFiles(files) {
      this.dragover = false
      // files.forEach(element => this.addUploadedFiles(element))
      let fileArray
      if (Array.isArray(files)) {
        fileArray = [...files]
      } else {
        fileArray = [files]
      }
      fileArray.forEach(element => this.addUploadedFiles(element))

      this.saveData()
      // if (this.instant) {
      //   this.saveData()
      // }
    },
    addUploadedFiles(element) {
      let tipas = element.name
        .toLowerCase()
        .split('.')
        .pop()
      if (!this.fileTypeList.includes(tipas)) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Netinkamas dokumento formatas, galima įkelti tik PDF, ADOC ir ASICE'
        )
        return
      }
      if (element.size > this.maxDydisByte) {
        window._VMA.$emit(
          'DATA_ERROR',
          `Leistinas dokumento dydis: ${this.maxDydis} MB`
        )
        return
      }
      this.uploadedFiles.push(element)
    },
    fileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return Math.round(size / 1024) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return Math.round(size / (1024 * 1024)) + ' MB'
      }
    },

    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(file => file.name === fileName)

      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1)
      this.saveData()
    },

    onDrop(e) {
      this.dragover = false

      // If there are already uploaded files remove them
      if (this.isUpload && !this.multiple) this.uploadedFiles = []

      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Vienu metu galima įkelti tik vieną doumentą'
        )
      }
      // Add each file to the array of uploaded files
      else {
        //e.dataTransfer.files.forEach(element => this.addUploadedFiles(element))
        const fileArray = [...e.dataTransfer.files]
        fileArray.forEach(element => this.addUploadedFiles(element))
      }

      this.saveData()
      // if (this.instant) {
      //   this.saveData()
      // }
    },
    updateProgress(progress) {
      this.progress = progress
    },
    saveData() {
      this.$emit('savedData', this.uploadedFiles)
    },
  },
}
</script>
<style lang="scss" scoped>
.fileInput {
  display: none;
}
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
